import { useState } from 'react'
import css from './DropdownInput.module.css'

interface DropdownInputProps {
    placeholder?: string
    error?: string
    disabled?: boolean
    onSubmit: (value: string, clearInput: () => void) => void
    onClearError?: () => void
    // Controlled mode: pass both to filter a list as the user types (the label picker).
    // Omit them and the input keeps its own state, submitting only on Enter.
    value?: string
    onChange?: (value: string) => void
    autoFocus?: boolean
}

const DropdownInput = ({ placeholder, error, disabled, onSubmit, onClearError, value: controlledValue, onChange, autoFocus }: DropdownInputProps) => {
    const [internalValue, setInternalValue] = useState('')
    const isControlled = controlledValue !== undefined
    const value = isControlled ? controlledValue : internalValue

    const setValue = (next: string) => {
        if (isControlled) onChange?.(next)
        else setInternalValue(next)
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value)
        if (error && onClearError) {
            onClearError()
        }
    }

    const clearInput = () => {
        setValue('')
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && value.trim()) {
            e.preventDefault()
            e.stopPropagation()
            onSubmit(value.trim(), clearInput)
        }
    }

    return (
        <div className={css.wrapper}>
            <input
                type="text"
                className={css.input}
                placeholder={placeholder}
                autoComplete="none"
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                disabled={disabled}
                autoFocus={autoFocus}
            />
            {error && <div className={css.error}>{error}</div>}
        </div>
    )
}

export default DropdownInput
